<template>
    <div>
        <navbar/>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4 ">
                    <h3>Nueva Nota</h3>
                    <div>
                        <textarea v-model="form.texto" class="form-control"></textarea>
                    </div>
                    <button @click="agregar">Add</button>
                </div>
                <div class="col-md-8 ">
                    <h3>Notas Casos</h3>
                    <div v-for="item in allNota" :key="item.id">
                        <span v-html="item.texto"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { log } from 'util'
export default {
    components:{
        navbar: () => import('@/views/Agente/navBar.vue')
    },
    data() {
        return {
            form: {
                idobjeto: Number(this.$route.params.id),
                privado: 1,
                tipoobjeto: this.$route.params.tipo
            }
        }
    },
    computed:{
        ...mapGetters('validatetoken', {
            allNota: 'allNota'
        }),
        Notas(){
            return{
                idobjeto: this.$route.params.id,
                tipoobjeto: this.$route.params.tipo,
                pagina: 1,
                cantidad: 10
            }
        }
    },
    methods: { 
        ...mapActions('validatetoken', { 
            getAllNotas: 'getAllNotas',
            addNota: 'addNota'
        }),
        getAll(){
            this.getAllNotas(this.Notas)
        },
        agregar(){
            this.addNota(this.form)
            .then(()=>{
                this.getAll()
            })
        }
    }, 
    created(){
        this.getAll()
    }
}
</script>

<style>

</style>